import script from "./config.vue?vue&type=script&setup=true&lang=js"
export * from "./config.vue?vue&type=script&setup=true&lang=js"

import "./config.vue?vue&type=style&index=0&id=368acf02&scoped=true&lang=css"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368acf02"]])

export default __exports__